import React from "react";
import { ProgressBar } from "../../../../../Other/ProgressBar/ProgressBar";
import { CourseBuilderStaticData } from "../../../../../../_constants/staticData";
const CourseQuestion = ({ handleInputChange, formValues, next, current }) => {
  return (
    <>
      <div className="box text-center">
        <div className={current === 0 ? "course-questions-wrapper" : "occlude"}>
          <h2 className="question-header">
            {CourseBuilderStaticData.step0.header}
          </h2>
          <p className="question-page">
            {CourseBuilderStaticData.step0.subHeader1}
          </p>
          <div>
            <ProgressBar
              barWidth={formValues.teacherExperience !== "" && "33%"}
            />
          </div>

          <p className="question-sub-header">
            {CourseBuilderStaticData.step0.subHeader2}
          </p>
          <div className="form-wrap-inputCourse">
            
            <label> {CourseBuilderStaticData.step0.label1}</label>
            <input
              aria-label="Yes, in person"
              type="radio"
              name="teacherExperience"
              value="Yes, in person"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step0.label2}</label>
            <input
              aria-label="Yes, online"
              type="radio"
              name="teacherExperience"
              value="Yes, online"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step0.label3}</label>
            <input
              aria-label="Yes, both online and in-person"
              type="radio"
              name="teacherExperience"
              value="Yes, both online and in-person"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step0.label4}</label>
            <input
              aria-label="No, I don’t have any teaching or training experience"
              type="radio"
              name="teacherExperience"
              value="No, I don’t have any teaching or training experience"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
        </div>
      </div>

      <div className="box text-center">
        <div className={current !== 1 && "occlude"}>
          <h2 className="question-header">
            {CourseBuilderStaticData.step1.header}
          </h2>
          <p className="question-page">
            {CourseBuilderStaticData.step1.subHeader1}
          </p>
          <div>
            <ProgressBar
              barMinWidth="33%"
              barWidth={formValues.experienceWithVideo !== "" && "66%"}
            />
          </div>
          <p className="question-sub-header">
            {CourseBuilderStaticData.step1.subHeader2}
          </p>
          <div className="form-wrap-inputCourse">
            <label> {CourseBuilderStaticData.step1.label1} </label>
            <input
              aria-label="No experience"
              type="radio"
              name="experienceWithVideo"
              value="No experience"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step1.label2}</label>
            <input
              aria-label="Beginner"
              type="radio"
              name="experienceWithVideo"
              value="Beginner"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step1.label3}</label>
            <input
              aria-label="Some experience"
              type="radio"
              name="experienceWithVideo"
              value="Some experience"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step1.label4} </label>
            <input
              aria-label="Very experienced"
              type="radio"
              name="experienceWithVideo"
              value="Very experienced "
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
        </div>
      </div>

      <div className="box text-center">
        <div className={current !== 2 && "occlude"}>
          <h2 className="question-header">
            {CourseBuilderStaticData.step2.header}
          </h2>
          <p className="question-page">
            {CourseBuilderStaticData.step2.subHeader1}
          </p>
          <div>
            <ProgressBar
              barMinWidth="66%"
              barWidth={formValues.courseReadiness !== "" && "100%"}
            />
          </div>
          <p className="question-sub-header">
            {CourseBuilderStaticData.step2.subHeader2}
          </p>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step2.label1}</label>
            <input
              aria-label="No, I have no current students"
              type="radio"
              name="courseReadiness"
              value="No, I have no current students"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step2.label2}</label>
            <input
              aria-label="Yes, I have a few students"
              type="radio"
              name="courseReadiness"
              value="Yes, I have a few students"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step2.label3}</label>
            <input
              aria-label="Yes, I have a full class"
              type="radio"
              name="courseReadiness"
              value="Yes, I have a full class"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
          <div className="form-wrap-inputCourse">
            <label>{CourseBuilderStaticData.step2.label4}</label>
            <input
              aria-label="Yes, I have more than one class"
              type="radio"
              name="courseReadiness"
              value="Yes, I have more than one class"
              onChange={({ target }) => handleInputChange(target)}
            />
          </div>
        </div>
      </div>

      <div className="box text-center">
        <div className={current !== 3 && "occlude"}>
          <div className="question-header">
            <p>{CourseBuilderStaticData.step3.subHeader}</p>
          </div>

          <button
            onClick={next}
            className="btn-blue "
            disabled={current === 3 ? false : true}
          >
            {CourseBuilderStaticData.step3.button}
          </button>
        </div>
      </div>
    </>
  );
};
export default CourseQuestion;




